import path from "path";

/**
 * 获取Dll加载路径和目录
 * 支持平台：Windows
 *
 * @param dllPath 用户config配置的加载dll路径，支持绝对路径和相对路径
 * @param currentDirection 当前程序运行exe根目录
 * @param dllName dll名称，现有：NmeoSDK.dll、SlaveNemoSDK.dll
 * @returns
 */
const getDllPath = (
  dllPath: string,
  currentDirection: string,
  dllName: string = "NemoSDK.dll"
) => {
  const setPath = dllPath;
  const isAbsolute = path.isAbsolute(setPath);
  const sdkDllName = dllName;
  let sdkDllPath = "";
  let sdkProjectPath = "";

  if (isAbsolute) {
    sdkDllPath = path.join(setPath, sdkDllName);
    sdkProjectPath = path.join(setPath);
  } else {
    sdkDllPath = path.join(currentDirection, setPath, sdkDllName);
    sdkProjectPath = path.join(currentDirection, setPath);
  }

  const result = {
    sdkDllPath,
    sdkProjectPath,
  };

  return result;
};

export const SDK_LOG_NAME = "js_c_wrapper.log";
export const SDK_SLAVE_LOG_NAME = "js_c_slave_wrapper.log";
export const SDK_SLAVE_NEMO_NAME = "xyslave.log";

/**
 * 获取日志路径
 * 支持WindowsXP，Windows 7+，Mac，Linux
 * windowsXP: C:\Documents and Settings\user\Application Data
 * Windows 7+: C:\Users\user\AppData\Roaming
 * Mac: /Users/user/Library/Application Support/xylink-electron
 * Linux: /home/user/.local/share
 *
 * @param configLogPath 用户配置的log路径，支持绝对和相对路径
 * @param logName 日志名称，现在默认：js_c_wrapper.log、js_c_slave_wrapper.log
 * @returns
 */
const getLogPath = (configLogPath: string, logName: string) => {
  const { env, platform } = process;
  const { APPDATA, HOME } = env;

  const logPath = configLogPath || "xylink-electron/logs";
  const sdkLogName = logName || SDK_LOG_NAME;
  const macAppdata = HOME + "/Library/Application Support";
  const linuxAppdata = HOME + "/.local/share";
  const winAppdata = APPDATA;

  const appDataPath =
    winAppdata || (platform == "darwin" ? macAppdata : linuxAppdata);
  const isAbsolute = path.isAbsolute(logPath);
  let sdkLogPath = "";
  let sdkLogDir = "";
  let sdkSlaveLogPath = "";

  if (isAbsolute) {
    sdkLogPath = path.join(logPath, sdkLogName);
    sdkSlaveLogPath = path.join(logPath, SDK_SLAVE_NEMO_NAME);
    sdkLogDir = path.join(logPath);
  } else {
    sdkLogPath = path.join(appDataPath, logPath, sdkLogName);
    sdkSlaveLogPath = path.join(appDataPath, logPath, SDK_SLAVE_NEMO_NAME);
    sdkLogDir = path.join(appDataPath, logPath);
  }

  return {
    sdkLogPath,
    sdkLogDir,
    sdkSlaveLogPath,
  };
};

export { getDllPath, getLogPath };
